import styled from "styled-components";
import color from "../../styles/color";

export const Container = styled.div`
  width: 460px;
`;
